export const ProjectsImageFour = ({ pic }) => {
  return (
    <div className="projects-artwork-container">
      <img className="projects-artwork-4" src={pic} alt=""></img>
    </div>
  );
};
